var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.emailCaseLog.length) ? _c('b-table', {
    attrs: {
      "data": _vm.emailCaseLog
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "caseid",
        "label": "Case ID"
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.props.row.caseid) + "\n        ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "allocationtype",
        "label": "Allocation Type"
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.props.row.allocationtype || '-') + "\n        ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "createdby",
        "label": "Created By"
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.props.row.createdby) + "\n        ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "createddate",
        "label": "Created Date"
      }
    }, [(_vm.props.row.createddate) ? _c('span', [_vm._v("\n          " + _vm._s(_vm._f("dateFiactiveComponentlter")(_vm.props.row.createddate)) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "status",
        "label": "Email Status"
      }
    }, [_c('span', {
      staticClass: "is-capitalized tag is-warning is-fullwidth is-normal",
      class: _vm.props.row.statusClass
    }, [_vm._v("\n          " + _vm._s(_vm.props.row.status) + "\n        ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "comment",
        "label": "Comment"
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.props.row.comment) + "\n        ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "label": "Email Preview"
      }
    }, [(_vm.props.row.caseid && _vm.props.row.status && _vm.props.row.status.toLowerCase() === 'close') ? _c('span', [_c('EmailPreview', {
      attrs: {
        "setCaseID": [_vm.props.row.caseid],
        "buttonType": 'eye'
      }
    })], 1) : _c('span', [_vm._v("-")])])]
  ], 2) : _vm._e(), _vm._v(" "), (!_vm.emailCaseLog.length) ? _c('div', {
    staticClass: "is-size-7 has-text-centered no_record"
  }, [_vm._m(0)]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content has-text-grey"
  }, [_vm._v("  \n      "), _c('span', {
    staticClass: "is-size-6"
  }, [_vm._v("No Records Found ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9634b46c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/emailCaseLog.vue
// module id = 920
// module chunks = 1